module.exports = __webpack_public_path__ + "static/img/23_yali.a136241d.png";